import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { errorManager } from '../../presentation/utils/errorManager';

/* eslint-disable no-unused-vars */
export const fetchClientDebt = async (token, params) => {
    try {
        const queryParams = new URLSearchParams({
            token: token,
            requestFrom: 'web'
        });

        params.forEach(param => {
            if (param.name === 'sku') {
                queryParams.append('sku', param.value);
            } else if (param.name === 'destination' || param.name === 'dni') {
                queryParams.append('destination', param.value);
            }
        });

        const peticion = await fetch(`${RemoteConstants.BASE_URL}debt/send/request?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    return data.data;
                } else {
                    errorManager(data.userMessage);
                    throw new Error(data.userMessage);
                }
            });

        return peticion;
    } catch (error) {
        console.error('❌ Error consultando deuda:', error);
        errorManager(error);
        throw error;
    }
}
